import React from "react";
import { useMapContext } from "./MapContext";
import { Marker } from "@react-google-maps/api";

export default function MarkerComponent({
  setOpen,
  providerMarker,
  clusterer,
}) {
  const { openCard, hover, baseUrl } = useMapContext();
  const {
    visible,
    firma,
    name,
    key,
    webseite,
    geo: { lat, lng },
  } = providerMarker;

  const { geo } = providerMarker;

  if (!geo) return <></>;

  const active = key === openCard?.key;

  const premium = webseite.includes("Premium Freigeschaltet");
  const type = premium ? "Premium" : firma.trim() !== "" ? "Company" : "Normal";

  return (
    <Marker
      noClustererRedraw
      clusterer={clusterer}
      position={{ lat, lng }}
      // label={{
      //   text: name[0],
      //   color: active ? "white" : key === hover ? "#a00a00" : "black",
      // }}
      title={name}
      // animation={window.google.maps.Animation.DROP}
      onClick={() => {
        setOpen(key);
      }}
      visible={visible}
      zIndex={active ? window.google.maps.Marker.MAX_ZINDEX + 1 : null}
      icon={{
        url: active
          ? `${baseUrl}/webcomponents/src/direflow-components/fvk-provider-map/icons/pin_${type}Active.svg`
          : key === hover
          ? `${baseUrl}/webcomponents/src/direflow-components/fvk-provider-map/icons/pin_${type}Hover.svg`
          : `${baseUrl}/webcomponents/src/direflow-components/fvk-provider-map/icons/pin_${type}.svg`,
        size: active
          ? new window.google.maps.Size(50, 50)
          : new window.google.maps.Size(30, 30),
        origin: active
          ? new window.google.maps.Point(0, 0)
          : new window.google.maps.Point(0, 0),
        anchor: active
          ? new window.google.maps.Point(25, 50)
          : new window.google.maps.Point(15, 30),
        scaledSize: active
          ? new window.google.maps.Size(50, 50)
          : new window.google.maps.Size(30, 30),
      }}
    />
  );
}
